<div class="note-display-container" #mainContainer>
	<ng-container *ngTemplateOutlet="viewType == 'STANDARD' ? standardTemplate : cardTemplate"></ng-container>

	<ng-template #standardTemplate>
		<ng-container *ngTemplateOutlet="noteDisplayTemplate"></ng-container>
	</ng-template>

	<ng-template #cardTemplate>
		<p-card [styleClass]="cardStyle">
			<ng-container *ngTemplateOutlet="noteDisplayTemplate"></ng-container>
		</p-card>
	</ng-template>
	
	<ng-template #noteDisplayTemplate>
		<ng-container *ngTemplateOutlet="headerTemplate"></ng-container>

		<div class="note-table-note"
             [innerHtml]="noteHtml! | trustHtml"
             [ngClass]="noteStyle"
             lb-events (afterViewInit)="configureState()"
        ></div>

		<p-divider *ngIf="note.safeHtmlNoteAbridged" styleClass="note-divider" align="center">
			<button pButton (click)="onNoteExpanderClicked()" class="p-button-rounded p-button-sm" 
				[title]="note.showAbridgedNote ? 'Show More' : 'Show Less'"
				icon="pi pi pi-caret-{{note.showAbridgedNote ? 'down' : 'up'}}">
			</button>
		</p-divider>
	</ng-template>
</div>